import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

const WeatherWidgetScreen = lazy(() => import('./weatherWidgetScreen'));

export const WeatherWidgetLazy = () => {
    return (
        <Suspense fallback={<WeatherWidgetLazyLoadingUI />}>
            <WeatherWidgetScreen />
        </Suspense>
    );
};

const WeatherWidgetLazyLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='100%' radius={1} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: -16px;
    margin-bottom: -17px;
    padding: 5px;
    width: 100%;
    height: calc(100vh - 13px);
`;